import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Grid,
} from '@mui/material';
import { Computer as ComputerIcon } from '@mui/icons-material';
import api from '../api';
import { showSuccess, showError } from '../utils/sweetAlertConfig';

const PRIMARY = "#29204C";

export default function CreateExamModal({ open, onClose, onSuccess, jobs }) {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    duration: 30,
    passing_score: 60,
    is_published: false,
    shuffle_questions: true,
    shuffle_options: true,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: e.target.type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async () => {
    if (!formData.title) {
      showError('Please enter exam title');
      return;
    }

    setLoading(true);
    try {
      await api.post('/exams', formData);
      showSuccess('Digital exam created successfully!');
      handleClose();
      onSuccess();
    } catch (error) {
      showError(error.response?.data?.message || 'Failed to create exam');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      title: '',
      description: '',
      duration: 30,
      passing_score: 60,
      is_published: false,
      shuffle_questions: true,
      shuffle_options: true,
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <ComputerIcon sx={{ color: PRIMARY }} />
          <Typography variant="h6">Create Digital Exam</Typography>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Exam Title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              required
            />
          </Grid>


          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Description"
              name="description"
              value={formData.description}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Duration (minutes)"
              name="duration"
              value={formData.duration}
              onChange={handleChange}
              inputProps={{ min: 1 }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Passing Score (%)"
              name="passing_score"
              value={formData.passing_score}
              onChange={handleChange}
              inputProps={{ min: 0, max: 100 }}
            />
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="shuffle_questions"
                  checked={formData.shuffle_questions}
                  onChange={handleChange}
                />
              }
              label="Shuffle Questions"
            />
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="shuffle_options"
                  checked={formData.shuffle_options}
                  onChange={handleChange}
                />
              }
              label="Shuffle Answer Options"
            />
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="is_published"
                  checked={formData.is_published}
                  onChange={handleChange}
                />
              }
              label="Publish Immediately"
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
          sx={{ bgcolor: PRIMARY, '&:hover': { bgcolor: '#1a1635' } }}
        >
          Create Exam
        </Button>
      </DialogActions>
    </Dialog>
  );
}
